<template>
  <div class="py-4 max-w-xl">
    <div class="bg-white shadow-2xl relative">
      <button
        v-if="editMode"
        class="category__save"
        :class="[!editMode ? 'bg-white' : 'bg-yellow-500']"
        @click="continueUpload"
      >
        <fa-icon class="text-white" :icon="['fas', 'upload']" size="xs" />
      </button>
      <button
        v-if="!editMode"
        class="category__delete bg-red-500"
        @click="delCategory"
      >
        <fa-icon class="text-white" :icon="['fas', 'trash']" size="xs" />
      </button>
      <button
        @click="editMode = !editMode"
        class="category__switch"
        :class="[!editMode ? 'bg-white' : 'bg-yellow-500 px-4']"
      >
        <fa-icon
          :class="[!editMode ? 'text-yellow-500' : 'text-white']"
          :icon="['fas', !editMode ? 'pen' : 'times']"
          size="xs"
        />
      </button>
      <div>
        <img v-if="!editMode" :src="category.image_path" />
        <div v-else>
          <DropZone
            ref="categoryDropZone"
            id="categoryDropZone"
            :options="dropZoneOptions"
            @vdropzone-sending="sendingEvent"
            @vdropzone-max-files-exceeded="maxFilesExceededEvent"
            @vdropzone-success="fileSavingSuccessEvent"
            @vdropzone-error-multiple="fileSavingErrorEvent"
          />
          <button class="category__dropzone-send" @click="saveCategory">
            <fa-icon
              :class="[!editMode ? 'text-yellow-500' : 'text-white']"
              :icon="['fas', 'save']"
              size="xs"
            />
          </button>
        </div>
      </div>
      <div class="px-4 py-2 bg-white">
        <h2 v-if="!editMode" class="font-bold text-2xl text-gray-800">
          {{ category.name }}
        </h2>
        <input
          v-else
          type="text"
          v-model="payload.name"
          class="text-2xl block w-full px-3 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner"
        />
        <p
          v-if="!editMode"
          class="sm:text-xl text-base text-gray-700 px-2 mr-1 my-3"
        >
          {{ category.sub_title }}
        </p>
        <input
          v-else
          type="text"
          v-model="payload.sub_title"
          class="text-2xl block w-full px-3 mt-2 text-gray-700 bg-gray-200 appearance-none focus:outline-none focus:bg-gray-300 focus:shadow-inner"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { updateCategory, deleteCategory } from '@/services/api/category.js'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import config from '@/config.js'

const apiUrl = config.apiUrl
// const MAX_FILES_POSSIBLE = 12

export default {
  components: {
    DropZone: vue2Dropzone
  },
  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      editMode: false,
      payload: null,
      dropZoneOptions: {
        url: `${apiUrl}category/image/${this.category.id}`,
        paramName: 'image',
        thumbnailWidth: 150,
        maxFilesize: 8,
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        dictDuplicateFile: 'This image is already in the dropzone!',
        acceptedFiles: 'image/*',
        withCredentials: true
      }
    }
  },
  methods: {
    getToken() {
      let name = 'XSRF-TOKEN='
      let decodedCookie = decodeURIComponent(document.cookie)
      let ca = decodedCookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    saveCategory() {
      updateCategory(this.payload).then(() => {
        this.editMode = false
      })
    },
    delCategory() {
      deleteCategory(this.category.id).then(() => {
        location.reload()
      })
    },
    sendingEvent(file, xhr) {
      xhr.setRequestHeader('X-XSRF-TOKEN', this.getToken())
    },
    maxFilesExceededEvent(file) {
      this.$refs.categoryDropZone.removeFile(file)
      alert('Max. number of images exceeded')
    },
    fileSavingSuccessEvent(files, response) {
      this.$emit('category-updated', response.id)
    },
    fileSavingErrorEvent(files, data, xhr) {
      if (xhr && data) {
        const errorOfModels = Object.entries(data.errors)
        const errors = errorOfModels.map(errorArray => {
          return errorArray[0]
        })
        console.log(errors)
      }
    },
    clearDropzone() {
      this.$refs.categoryDropZone.removeAllFiles()
    },
    continueUpload() {
      this.$refs.categoryDropZone.processQueue()
    }
  },
  mounted() {
    this.payload = this.category
  }
}
</script>
<style lang="sass">
.category
    &__dropzone-send
        @apply w-full bg-yellow-500
    &__save
        z-index: 5000
        @apply rounded-full border-yellow-500 border-2 absolute top-0 left-0 ml-2 px-3 mt-2
    &__delete
        z-index: 5000
        @apply rounded-full border-red-500 border-2 absolute top-0 left-0 ml-2 px-3 mt-2
    &__switch
        z-index: 5000
        @apply rounded-full border-yellow-500 border-2 absolute top-0 right-0 mr-2 px-3 mt-2

#categoryDropZone
    & .dz-image
        display: flex !important
        justify-content: center !important
    &>.dz-preview
        @apply w-full mx-auto
        & .dz-details
            @apply bg-yellow-500
</style>
